<template>
  <a-dialog
      ref="dialog"
      :persistent="false"
      size="large"
      name="manage_exports"
      :loading="loading"
      @open="opened"
      @close="$reset">
    <span slot="title">{{ $t('manage-exports') }}</span>
    <div slot="content">
      <tab-select
          :items="[$t('tabs-creation'), $t('tabs-scheduling')]"
          :value.sync="tab"
          class="mb-4">
      </tab-select>

      <div v-if="tab === 0">
        <p class="mb-4">
          {{ $t('create-export-description') }}
        </p>
        <export-form :ids="ids" :value.sync="fields.create"></export-form>
      </div>
      <div v-if="tab === 1">
        <p class="mb-4">
          {{ $t('schedule-export-description') }}
        </p>
        <schedule-exports :ids="ids"></schedule-exports>
      </div>
    </div>
    <span slot="actions" v-if="tab === 0">
      <v-btn v-if="tab === 0" color="primary" text @click="submit">
        {{ $t('generate') }}
      </v-btn>
    </span>
  </a-dialog>
</template>

<script>
import TabSelect from '@/views/Common/Components/TabSelect'
import ExportForm from '@/views/Pages/PositionMonitoring/Dialogs/ManageExportsDialog/Components/ExportForm'
import ScheduleExports from '@/views/Pages/PositionMonitoring/Dialogs/ManageExportsDialog/Components/ScheduleExports'

export default {
  name: 'ManageExportsDialog',
  components: { ScheduleExports, ExportForm, TabSelect },
  data () {
    return {
      tab: 0,

      loading: '',
      date: null,
      ids: [],

      fields: {
        create: {}
      }
    }
  },
  methods: {
    async opened ({ date, ids }) {
      this.date = date
      console.log(this.date)
      this.ids = ids.slice(0, this.$account.current.rules['check-position'].max_monitor)
    },
    async submit () {
      this.loading = this.$t('export-in-progress')

      try {
        let response = null
        if(this.fields.create.type === 'raw') {
          response = await this.$api.post('monitors/generate_export', {
            type: 'raw',
            ...this.date,
            ...this.fields.create.options.raw,
            targets: this.fields.create.targets,
          })
        } else {
          response = await this.$api.post('monitors/generate_export', {
            type: this.fields.create.type,
            current: this.date.current,
            ...this.fields.create.options.report,
            targets: this.fields.create.targets,
          })
        }

        this.$bus.emit('ui/download', response.data.file)
        if (this.$refs.dialog) this.$refs.dialog.close()
      } finally {
        this.loading = ''
      }
    }
  }
}
</script>

<i18n>
{
	"en": {
		"create-export-description": "Download a raw data export corresponding to the day you are currently viewing or a report of your positions from a time interval.",
		"export-in-progress": "Export in progress...",
		"generate": "Generate",
		"manage-exports": "Manage my exports",
		"schedule-export-description": "Schedule position reports to be sent to a list of recipients via scheduled emails",
		"tabs-creation": "Creation",
		"tabs-scheduling": "Scheduling"
	},
	"es": {
		"create-export-description": "Descargue una exportación de datos sin procesar correspondiente al día que está viendo actualmente o un informe de sus posiciones de un intervalo de tiempo.",
		"export-in-progress": "Exportando ...",
		"generate": "Generar",
		"manage-exports": "Administrar mis exportaciones",
		"schedule-export-description": "Programe informes de posición para que se envíen a una lista de destinatarios a través de correos electrónicos programados.",
		"tabs-creation": "creación",
		"tabs-scheduling": "Planificación"
	},
	"fr": {
		"create-export-description": "Téléchargez un export de données brutes correspondant à la journée que vous consultez actuellement ou un rapport de vos positions d'un interval de temps.",
		"export-in-progress": "Exportation en cours...",
		"generate": "Générer",
		"manage-exports": "Gérer mes exports",
		"schedule-export-description": "Planifiez l'envoi de rapports de positions à une liste de destinataires via des emails programmés.",
		"tabs-creation": "Création",
		"tabs-scheduling": "Programmation"
	},
	"it": {
		"create-export-description": "Scarica un'esportazione di dati grezzi corrispondente al giorno che stai visualizzando o un rapporto delle tue posizioni in un intervallo di tempo.",
		"export-in-progress": "Esportazione in corso...",
		"generate": "Genera",
		"manage-exports": "Gestisci le mie esportazioni",
		"schedule-export-description": "Pianifica l'invio di rapporti di posizioni a una lista di destinatari tramite email programmate.",
		"tabs-creation": "Creazione",
		"tabs-scheduling": "Pianificazione"
	},
	"pt": {
		"create-export-description": "Transfira uma exportação de dados brutos correspondente ao dia que está a visualizar ou um relatório das suas posições de um intervalo de tempo.",
		"export-in-progress": "Exportação em curso...",
		"generate": "Gerar",
		"manage-exports": "Gerir as minhas exportações",
		"schedule-export-description": "Agende o envio de relatórios de posições para uma lista de destinatários por email programado.",
		"tabs-creation": "Criação",
		"tabs-scheduling": "Agendamento"
	},
	"pl": {
		"create-export-description": "Pobierz eksport surowych danych odpowiadający dniu, który aktualnie przeglądasz, lub raport swoich pozycji z określonego przedziału czasowego.",
		"export-in-progress": "Eksport w toku...",
		"generate": "Generuj",
		"manage-exports": "Zarządzaj moimi eksportami",
		"schedule-export-description": "Zaplanuj wysyłanie raportów pozycji do listy odbiorców za pomocą zaplanowanych e-maili.",
		"tabs-creation": "Tworzenie",
		"tabs-scheduling": "Planowanie"
	}
}
</i18n>
